import { Link, useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  // Smooth custom scroll function
  const slowEasedScroll = (targetId, duration = 3000) => {
    const target = document.getElementById(targetId);

    if (!target) {
      window.location.href = `/#${targetId}`;
      return;
    }

    const startPosition = window.scrollY;
    const targetPosition = target.getBoundingClientRect().top + startPosition;
    const distance = targetPosition - startPosition;
    let startTime = null;

    const easeInOutQuad = (t) => {
      return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
    };

    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      const easeProgress = easeInOutQuad(progress);
      window.scrollTo(0, startPosition + distance * easeProgress);

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      } else {
        history.pushState(null, "", `#${targetId}`);
      }
    };

    requestAnimationFrame(animation);
  };

  // Updated navigation click handler
  const handleNavClick = (target) => {
    setMenuOpen(false); // Close menu on mobile after clicking

    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        slowEasedScroll(target);
      }, 100);
    } else {
      slowEasedScroll(target);
    }
  };

  return (
    <header className="fixed top-0 left-0 w-full bg-black text-white p-4 shadow-md z-50">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        
        {/* Logo with Descriptive Alt Text */}
        <Link to="/" aria-label="Homepage">
          <img 
            src="/images/uro_logo.jpg" 
            alt="Dr. Srikanth Urology Clinic - Best Urologist in Bengaluru" 
            className="h-14"
            loading="lazy" 
          />
        </Link>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="2"
            aria-hidden="true"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Navigation Menu */}
        <nav 
          className={`absolute md:static top-16 left-0 w-full md:w-auto bg-black md:bg-transparent flex flex-col md:flex-row items-center md:space-x-6 transition-all duration-300 ease-in-out ${
            menuOpen ? "flex" : "hidden md:flex"
          }`}
          aria-label="Main navigation"
        >
          <ul className="flex flex-col md:flex-row md:gap-6 items-center w-full md:w-auto text-center text-lg">
            {[
              { label: "Home", id: "home" },
              { label: "About Us", id: "about" },
              { label: "Services", id: "services" },
              { label: "Contact", id: "contact" }
            ].map(({ label, id }) => (
              <li key={id}>
                <button 
                  onClick={() => handleNavClick(id)} 
                  className={`hover:text-blue-600 block py-2 relative ${location.hash === `#${id}` ? "border-b-2 border-blue-500" : ""}`}
                  aria-label={`Go to ${label} Section`}
                >
                  {label}
                </button>
              </li>
            ))}

            <li>
              <Link 
                to="/feedback" 
                className="hover:text-blue-600 block py-2"
                aria-label="Go to Feedback Page"
              >
                Feedback
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
